(()=>{
  const init=()=>{
    document.querySelectorAll('[data-live-strip]').forEach(strip=>{
      if(strip.dataset.ready)return;
      strip.dataset.ready='true';
      const button=strip.querySelector('[data-live-toggle]');
      if(!button)return;
      button.addEventListener('click',()=>{
        const paused=strip.dataset.paused!=='true';
        strip.dataset.paused=String(paused);
        button.setAttribute('aria-pressed',String(paused));
        button.setAttribute('aria-label',paused?button.dataset.resumeLabel:button.dataset.pauseLabel);
      });
    });
  };
  const sticky=document.querySelector('[data-sticky-buy]');
  let frame=0;
  const placeContact=()=>{
    cancelAnimationFrame(frame);
    frame=requestAnimationFrame(()=>{
      const visible=sticky?.classList.contains('is-visible')&&getComputedStyle(sticky).display!=='none';
      const bottom=visible?sticky.getBoundingClientRect().height+14:innerWidth>700?24:18;
      document.documentElement.style.setProperty('--fn-contact-bottom',`${bottom}px`);
    });
  };
  init();placeContact();
  document.addEventListener('shopify:section:load',init);
  addEventListener('resize',placeContact,{passive:true});
  if(sticky){
    new MutationObserver(placeContact).observe(sticky,{attributes:true,attributeFilter:['class']});
    new ResizeObserver(placeContact).observe(sticky);
    sticky.addEventListener('transitionend',placeContact);
  }
})();
